import { NamePath } from 'antd/es/form/interface'
import { get, set } from 'lodash'

// type FormValuesSingle = [NamePath, any]
// type FormValuesMulti = { list: FormValuesSingle[] }
// type FormValues = FormValuesSingle | FormValuesMulti
export type FormValuesSingle<T = unknown> = [NamePath, T]
export type FormValuesMulti<T = unknown> = { list: FormValuesSingle<T>[] }
export type FormValues<T = unknown> = FormValuesSingle<T> | FormValuesMulti<T>
type ComponentKey<R> = Extract<keyof R, string>

const isComponentField = <R extends Record<string, any>>(
    name: NamePath,
    componentKeys: readonly ComponentKey<R>[]
) => {
    return (
        Array.isArray(name) &&
        name.length >= 2 &&
        // CALC_POS_COMPONENT_KEYS.includes(name[0] as string)
        componentKeys.includes(name[0] as ComponentKey<R>)
    )
}

const isEmptyValue = (value: any) => {
    return (
        value === undefined ||
        value === null ||
        value === '' ||
        value === 0 ||
        (Array.isArray(value) && value.length === 0)
    )
}

/**
 * Функция используется в разных таблицах!
 */
export function getDataForUpdate<R extends Record<string, any>, TValue = any>(
    record: R,
    formValues: FormValues<TValue>,
    options: { componentKeys: readonly ComponentKey<R>[] } = {
        componentKeys: [] as readonly ComponentKey<R>[],
    }
): Record<string, any> {
    const pairs: FormValuesSingle<TValue>[] = 'list' in formValues ? formValues.list : [formValues]

    const data: Record<string, any> = {}

    for (const [name, value] of pairs) {
        const isRelationSetPath = Array.isArray(name) && name[name.length - 1] === 'set'

        if (isComponentField<R>(name, options.componentKeys)) {
            const componentKey = name[0] as ComponentKey<R>
            const existing = get(record, componentKey) ?? {}
            const current = data[componentKey as string] ?? { ...existing }
            const field = name[1]
            const component = get(record, componentKey) as { id?: number } | undefined

            if (isRelationSetPath) {
                data[componentKey as string] = {
                    ...current,
                    [field]: { set: isEmptyValue(value) ? [] : value },
                    ...(component?.id != null && { id: component.id }),
                }
            } else {
                data[componentKey as string] = {
                    ...current,
                    [field]: value,
                    ...(component?.id != null && { id: component.id }),
                }
            }
        } else if (isRelationSetPath) {
            set(data, name, isEmptyValue(value) ? [] : value)
        } else {
            set(data, name, value)
        }
    }

    return data
}
